/** Query param that tells the properties page where to send the user after a property is added. */
export const REDIRECT_TO_PARAM = 'redirectTo';
export const REDIRECT_TO_PAYMENTS = 'payments';
